export default __webpack_public_path__ + "static/media/casinoFruitRace1Hin.62262478.jpg";